import React from "react";
import { motion } from "framer-motion";
import { Eye, MessagesSquare, Wrench, FileText, UserCheck } from "lucide-react";

const items = [
  { icon: Eye, title: "Proceso claro", text: "Tienes visibilidad completa de cada fase, sin sorpresas." },
  { icon: MessagesSquare, title: "Comunicación continua", text: "Te informamos en cada paso, de forma directa y honesta." },
  { icon: Wrench, title: "Inspección previa", text: "Verificamos el vehículo en persona antes de cualquier compromiso." },
  { icon: FileText, title: "Apoyo documental", text: "Gestionamos toda la documentación legal y fiscal." },
  { icon: UserCheck, title: "Guía profesional", text: "Asesoramiento experto en cada decisión importante." },
];

export const Trust = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5 overflow-hidden" data-testid="trust-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full opacity-40"
          style={{ background: "radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%)" }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-16 text-center mx-auto"
        >
          <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Confianza & transparencia</span>
          <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
            La transparencia es nuestro principio fundamental.
          </h2>
          <p className="mt-6 text-base text-[#A3A3A3] leading-relaxed font-light">
            No vendemos coches. Te acompañamos en tu compra. Por eso cada paso del
            proceso es claro, verificable y orientado a tu tranquilidad.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group bg-white/[0.02] backdrop-blur-md border border-white/10 p-7 hover:border-[#D4AF37]/40 hover:bg-white/[0.05] transition-all duration-500"
              data-testid={`trust-card-${i}`}
            >
              <div className="w-11 h-11 border border-[#D4AF37]/30 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/10 transition-colors">
                <it.icon className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.2} />
              </div>
              <h3 className="font-heading text-base font-medium text-[#FFFFF0] mb-2">{it.title}</h3>
              <p className="text-sm text-[#A3A3A3] leading-relaxed font-light">{it.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
